export default "__VITE_ASSET__Bfd_1YLD__"